import { render, staticRenderFns } from "./DialogConfirmarEmail.vue?vue&type=template&id=0dea6124&scoped=true&"
import script from "./DialogConfirmarEmail.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmarEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dea6124",
  null
  
)

export default component.exports